import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const DIALOG_TYPE = 'update-deposit-request';

@Component({
  selector: 'app-update-deposit-request-dialog',
  templateUrl: './update-deposit-request-dialog.component.html',
  styleUrls: ['./update-deposit-request-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateDepositRequestDialogComponent implements OnInit {
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  onUpdateDepositRequest: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  onCancelDepositRequest: EventEmitter<void> = new EventEmitter<void>();

  trackingObject: ITrackingObject;
  primaryActionTapped: ITrackingAction;
  secondaryActionTapped: ITrackingAction;
  dialogType: string;

  constructor(
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.update_deposit_request
    );
    this.primaryActionTapped = this._trackingActionBuilder.buildButtonTapped(
      'yes',
      this.trackingScreenName
    );
    this.secondaryActionTapped = this._trackingActionBuilder.buildButtonTapped(
      'no',
      this.trackingScreenName
    );
  }
}
